<template>
  <div class="edit-tax-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="130px"
        :label-position="labelPosition"
      >
        <el-form-item label="金币税率:" prop="coinTax">
          <el-input v-model.number="params.coinTax" size="small"></el-input>
        </el-form-item>
        <el-form-item label="代理税率:" prop="cashTax">
          <el-input v-model.number="params.cashTax" size="small"></el-input>
        </el-form-item>

        <el-form-item label="商区自提税率:" prop="discCashTax">
          <el-input v-model.number="params.discCashTax" size="small"></el-input>
        </el-form-item>
        <el-form-item label="商区财务税率:" prop="discFinanceTax">
          <el-input v-model.number="params.discFinanceTax" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      params: {
        coinTax: "",
        cashTax: "",
        discCashTax: "",
        discFinanceTax: ""
      },
      rules: {
        coinTax: [
          { required: true, message: "请输入金币提现税率", trigger: "blur" },
          { type: "number", message: "提现税率必须为数字" }
        ],
        cashTax: [
          { required: true, message: "请输入代理提现税率", trigger: "blur" },
          { type: "number", message: "提现税率必须为数字" }
        ],
        discCashTax: [
          { type: "number", message: "提现税率必须为数字", trigger: "blur"  }
        ],
        discFinanceTax: [
          { type: "number", message: "提现税率必须为数字", trigger: "blur"  }
        ]
      }
    };
  },
  methods: {
    // 提交修改
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.flag = true;
          this.editChannel();
        } else {
          return false;
        }
      });
    },
    // 修改提现税率配置
    editChannel() {
      API.updateTax(this.params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "修改提现税率成功",
              type: "success"
            });
            this.$emit("handlerChannelList");
          } else {
            this.$message.error("修改提现税率失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        coinTax: "",
        cashTax: "",
        discCashTax: "",
        discFinanceTax: ""
      };
      this.$refs["form"].resetFields();
    },
    // 打开修改提现税率弹框
    open(data) {
      this.dialogVisible = true;
      this.title = "编辑提现税率";
      this.params.coinTax = data.coinTax;
      this.params.cashTax = data.cashTax;
      this.params.discCashTax = data.discCashTax;
      this.params.discFinanceTax = data.discFinanceTax;
    }
  }
};
</script>

<style lang="scss" >
.edit-tax-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
